module.exports = __webpack_public_path__ + "static/media/IMG_3872.8bc474cc.jpg";